import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import authService from '@/services/auth';

/**
 * Registrar Usuário (register-user.vue): formulario simples de cadastro
 * de um novo usuario, usado por usuarios logados (nao e' a tela publica
 * de auto-cadastro). Ao concluir, redireciona para o login (mesmo
 * comportamento do Vue original).
 */
export default function Register() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const registrar = async () => {
    setErrorMessage('');
    setSuccessMessage('');
    if (password !== passwordConfirm) {
      setErrorMessage('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      await authService.register({
        username,
        email,
        password,
        password_confirm: passwordConfirm,
      });
      setSuccessMessage('Usuário registrado com sucesso!');
      setTimeout(() => navigate('/login'), 2000);
    } catch (error: any) {
      console.error('Erro ao registrar usuário', error);
      const data = error?.response?.data;
      const msg = data ? Object.values(data).flat().join(' ') : 'Erro ao registrar usuário';
      setErrorMessage(msg || 'Erro ao registrar usuário');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md">
      <div className="rounded-lg bg-white p-6 shadow-sm">
        <div className="mb-4 flex items-center gap-2">
          <UserPlus className="h-6 w-6 text-sky-600" />
          <h2 className="text-xl font-bold text-slate-800">Registrar Usuário</h2>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            registrar();
          }}
          className="space-y-4"
        >
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Nome de Usuário</label>
            <input value={username} onChange={(e) => setUsername(e.target.value)} required className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">E-mail</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Senha</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Confirmar Senha</label>
            <input type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} required minLength={6} className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm" />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-md bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700 disabled:opacity-60"
          >
            {loading ? 'Registrando...' : 'Registrar'}
          </button>
        </form>

        {errorMessage && (
          <div className="mt-4 rounded-md bg-red-100 p-3 text-sm text-red-700">{errorMessage}</div>
        )}
        {successMessage && (
          <div className="mt-4 rounded-md bg-emerald-100 p-3 text-sm text-emerald-700">{successMessage}</div>
        )}
      </div>
    </div>
  );
}
